export const arrayToString = (itemLabel) =>
  itemLabel !== null && itemLabel !== undefined && typeof itemLabel === 'object'
    ? itemLabel.map((itemValue) => itemValue.label).join(', ')
    : '';
